export default function About() {
  return (
    <section className="page-content">
      {/* <h1><em>About</em></h1> */}
      {/* <hr /> */}
      <p>
        WAABM stands for <em>We Are All Beautiful Minds</em> — a philosophy rooted in the
        belief that creativity is universal, and that every person carries a unique perspective
        worth sharing with the world.
      </p>
      <p>
        Founded as a creative collective, WAABM.music is a platform for independent artists,
        musicians, and thinkers who believe in the transformative power of sound and
        collaboration. We celebrate the full spectrum of human expression — from intimate
        bedroom recordings to large-scale experimental works.
      </p>
      <p>
        From the first note to the final mix, everything we do is guided by one simple
        conviction: when we create together, we become something greater than ourselves.
        Join us in exploring what it means to make something meaningful.
      </p>
    </section>
  );
}
